import React, { useState, useEffect } from "react";
import axios from "axios";
import './PFdetails.css';
import Select from 'react-select';

const PFdetails = () => {
  const [designation, setDesignation] = useState(null);
  const [designationOptions, setDesignationOptions] = useState([]);
  const [aadhar, setAadhar] = useState('');
  const [uanNumber, setUanNumber] = useState('');
  const [relation, setRelation] = useState('');
  const [number, setNumber] = useState('');
  const [mailId, setMailId] = useState('');
  const [panNumber, setPanNumber] = useState('');
  const [accountNumber, setAccountNumber] = useState('');
  const [ifscCode, setIfscCode] = useState('');
  const [isFocused, setIsFocused] = useState(false);
  const isFormValid =
    designation &&
    aadhar &&
    uanNumber &&
    relation &&
    number &&
    mailId &&
    panNumber &&
    accountNumber &&
    ifscCode;
  const isAadharValid = /^\d{12}$/.test(aadhar);
  useEffect(() => {
    const fetchDesignations = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/designation`);
        const options = response.data.map(item => ({
          value: item.DESIGNATION_ID,
          label: item.DESIGNATION_NAME
        }));
        setDesignationOptions(options);
      } catch (error) {
        console.error('Error fetching designations:', error);
      }
    };

    fetchDesignations();
  }, []);
  const customStyles = {
    singleValue: (provided) => ({
      ...provided,
      textAlign: "left",
    }),
    valueContainer: (provided) => ({
      ...provided,
      textAlign: "left",
    }),
    placeholder: (provided) => ({
      ...provided,
      textAlign: "left",
    }),
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = {
      designation: designation?.value,
      aadhar,
      uanNumber,
      relation,
      number,
      mailId,
      panNumber,
      accountNumber,
      ifscCode,
    };

    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/pfdetails`, data);
      alert("PF details submitted successfully.");
    } catch (error) {
      console.error("Error submitting PF details:", error);
      alert("Failed to submit PF details.");
    }
  };

  return (
    <div className="pfdetails-main">
      <div className="pfdetails-box">
        <h2 className="pfdetails-heading">PF Details</h2>
        <form onSubmit={handleSubmit}>
          <div
            className={`pfdetails-input-container ${isFocused || designation ? "focused filled" : ""
              }`}
          >
            <Select
              styles={customStyles}
              options={designationOptions}
              value={designation}
              onChange={setDesignation}
              onFocus={() => setIsFocused(true)}
              onBlur={() => setIsFocused(false)}
              placeholder=""
            />
            <label>Designation:</label>
          </div>
          <div className="pfdetails-input-container">

            <input value={aadhar} onChange={(e) => setAadhar(e.target.value.replace(/\D/g, ""))} placeholder="" maxLength={12} />
            <label>Aadhar:</label>
            {!isAadharValid && aadhar && (
              <small className="error-message">Enter valid 12-digit Aadhar</small>
            )}
          </div>
          <div className="pfdetails-input-container">

            <input value={uanNumber} onChange={(e) => setUanNumber(e.target.value)} placeholder="" />
            <label>UAN No:</label>
          </div>
          <div className="pfdetails-input-container">

            <input value={relation} onChange={(e) => setRelation(e.target.value)} placeholder="" />
            <label>Relation:</label>
          </div>
          <div className="pfdetails-input-container">

            <input value={number} onChange={(e) => setNumber(e.target.value.replace(/\D/g, ""))} placeholder="" maxLength={10} />
            <label>PHN Number:</label>
          </div>
          <div className="pfdetails-input-container">
            <input
              value={mailId}
              onChange={(e) => setMailId(e.target.value)}
              placeholder=""
              className={
                mailId && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mailId)
                  ? "input-error"
                  : ""
              }
            />
            <label>Email Id:</label>
            {mailId && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mailId) && (
              <small className="error-message">
                Invalid email format.
                <strong>example@domain.com</strong>
              </small>
            )}
          </div>

          <div className="pfdetails-input-container">
            <input
              value={panNumber}
              onChange={(e) => setPanNumber(e.target.value.toUpperCase())} // convert to uppercase
              placeholder=""
              maxLength={10}
              className={
                panNumber && !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(panNumber)
                  ? "input-error"
                  : ""
              }
            />
            <label>PAN Number:</label>
            {panNumber && !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(panNumber) && (
              <small className="error-message">
                Invalid PAN format.
                <strong>ABCDE1234F</strong>
              </small>
            )}
          </div>

          <div className="pfdetails-input-container">

            <input value={accountNumber} onChange={(e) => setAccountNumber(e.target.value)} placeholder="" />
            <label>Account Number:</label>
          </div>
          <div className="pfdetails-input-container">
            <input
              value={ifscCode}
              onChange={(e) => setIfscCode(e.target.value.toUpperCase())} // auto uppercase
              placeholder=""
              maxLength={11}
              className={
                ifscCode && !/^[A-Z]{4}0[A-Z0-9]{6}$/.test(ifscCode)
                  ? "input-error"
                  : ""
              }
            />
            <label>IFSC Code:</label>
            {ifscCode && !/^[A-Z]{4}0[A-Z0-9]{6}$/.test(ifscCode) && (
              <small className="error-message">
                Invalid IFSC format.<strong>ABCD0XXXXXX</strong>
              </small>
            )}
          </div>

          <button type="submit" className="pfdetails-save" disabled={!isFormValid}>Save</button>
        </form>
      </div>
    </div>
  );
};

export default PFdetails;
